export default {
    create_unittype_create_title: "New Unit Type",
    create_unittype_edit_title: "Edit Unit Type",
    create_unittype_create_success_message: "The unit type has been created",
    create_unittype_update_success_message: "The unit type has been edited",
    create_unittype_manufacturer: "Manufacturer",
    create_unittype_name: "Name",
    create_unittype_uses_sim: "Uses SIM",
    create_unittype_use_imei_as_serial: "Use IMEI as Serial Number",
    create_unittype_active: "Active",
    create_unittype_database: "Database",
    create_unittype_error_create_general: "Error creating unit type",
    create_unittype_error_update_general: "Error updating unit type",
    create_unittype_error_same_name: "A unit type with the same name already exists",
}